<div class="padding flex column fixed-width">
  <h4 class="bold margin-bottom-small">Add products</h4>

  @if (!isCustom) {
    <div class="flex column">
      <b>
        <i class="fa fa-industry"></i>
        Warehouse
      </b>

      <div class="flex center">
        <div class="flex center margin-top-small">
          <div class="flex-1 fix-width-ware border blue padding-small flex center">
            @if (warehouse) {
              {{ warehouse.code }} - {{ warehouse.description }}
            } @else {
              Select a warehouse
            }
          </div>
          <button
            type="button"
            class="flex-0 radius-left-none"
            [disabled]="warehouseDisabled"
            (click)="openWarehouseFilterModal()"
          >
            <i class="fa-solid fa-edit"></i>
            Edit
          </button>
        </div>
      </div>
    </div>
  }

  <div class="flex margin-top end {{ warehouse || isCustom ? '' : 'disabled' }}">
    <div class="flex-1 flex column">
      <div class="flex center">
        <b>Select styles</b>
      </div>

      <!-- Filters -->
      <div class="flex center wrap margin-top-small gap">
        <div class="filter-chip mini" [ngClass]="!stylesFilters.styleCode ? '' : 'selected'">
          @if (stylesFilters.styleCode) {
            <div class="flex center hover" (click)="openStyleCodesFilter()">
              <b class="margin-right-smallest">Style Code:</b>
              {{ stylesFilters.styleCode }}
            </div>

            <mat-icon class="hover" (click)="cleanFilter('styleCode')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openStyleCodesFilter()">
              Style Code
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.statuses || !stylesFilters.statuses.length ? '' : 'selected'"
        >
          @if (stylesFilters.statuses && stylesFilters.statuses.length) {
            <div class="flex center hover" (click)="openStatusFilterModal()">
              <b class="margin-right-smallest">Status:</b>

              @for (status of stylesFilters.statuses; track status; let last = $last) {
                {{ status.name }}
                @if (!last) {
                  ,
                }
              }
            </div>

            <mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openStatusFilterModal()">
              Status
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.brands || !stylesFilters.brands.length ? '' : 'selected'"
        >
          @if (stylesFilters.brands && stylesFilters.brands.length) {
            <div class="flex center hover" (click)="openBrandFilterModal()">
              <b class="margin-right-smallest">Brand:</b>

              @for (brand of stylesFilters.brands; track brand; let last = $last) {
                {{ brand.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openBrandFilterModal()">
              Brand
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.categories || !stylesFilters.categories.length ? '' : 'selected'"
        >
          @if (stylesFilters.categories && stylesFilters.categories.length) {
            <div class="flex center hover" (click)="openCategoryFilterModal()">
              <b class="margin-right-smallest">Category:</b>
              @for (category of stylesFilters.categories; track category; let last = $last) {
                {{ category.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('categories')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openCategoryFilterModal()">
              Category
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.styleGroups || !stylesFilters.styleGroups.length ? '' : 'selected'"
        >
          @if (stylesFilters.styleGroups && stylesFilters.styleGroups.length) {
            <div class="flex center hover" (click)="openStyleGroupFilterModal()">
              <b class="margin-right-smallest">Style Group:</b>
              @for (styleGroup of stylesFilters.styleGroups; track styleGroup; let last = $last) {
                {{ styleGroup.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('styleGroups')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openStyleGroupFilterModal()">
              Style Group
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.styleDescriptions || !stylesFilters.styleDescriptions.length ? '' : 'selected'"
        >
          @if (stylesFilters.styleDescriptions && stylesFilters.styleDescriptions.length) {
            <div class="flex center hover" (click)="openStyleDescriptionFilterModal()">
              <b class="margin-right-smallest">Style Description:</b>
              @for (styleDescription of stylesFilters.styleDescriptions; track styleDescription; let last = $last) {
                {{ styleDescription.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('styleDescriptions')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openStyleDescriptionFilterModal()">
              Style Description
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.collections || !stylesFilters.collections.length ? '' : 'selected'"
        >
          @if (stylesFilters.collections && stylesFilters.collections.length) {
            <div class="flex center hover" (click)="openCollectionFilterModal()">
              <b class="margin-right-smallest">Collection:</b>
              @for (collection of stylesFilters.collections; track collection; let last = $last) {
                {{ collection.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('collections')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openCollectionFilterModal()">
              Collection
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.purposes || !stylesFilters.purposes.length ? '' : 'selected'"
        >
          @if (stylesFilters.purposes && stylesFilters.purposes.length) {
            <div class="flex center hover" (click)="openPurposeFilterModal()">
              <b class="margin-right-smallest">Purpose:</b>
              @for (purpose of stylesFilters.purposes; track purpose; let last = $last) {
                {{ purpose.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('purposes')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openPurposeFilterModal()">
              Purpose
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div
          class="filter-chip mini"
          [ngClass]="!stylesFilters.genders || !stylesFilters.genders.length ? '' : 'selected'"
        >
          @if (stylesFilters.genders && stylesFilters.genders.length) {
            <div class="flex center hover" (click)="openGenderFilterModal()">
              <b class="margin-right-smallest">Gender:</b>
              @for (gender of stylesFilters.genders; track gender; let last = $last) {
                {{ gender.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('genders')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openGenderFilterModal()">
              Gender
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>

        <div class="filter-chip mini" [ngClass]="!stylesFilters.teams || !stylesFilters.teams.length ? '' : 'selected'">
          @if (stylesFilters.teams && stylesFilters.teams.length) {
            <div class="flex center hover" (click)="openTeamFilterModal()">
              <b class="margin-right-smallest">Team:</b>
              @for (team of stylesFilters.teams; track team; let last = $last) {
                {{ team.name }}
                @if (!last) {
                  ,
                }
              }
            </div>
            <mat-icon class="hover" (click)="cleanFilter('teams')">close</mat-icon>
          } @else {
            <div class="flex center hover" (click)="openTeamFilterModal()">
              Team
              <mat-icon class="hover">edit</mat-icon>
            </div>
          }
        </div>
      </div>

      @if (loadingStyles) {
        <div class="margin-top-small full-width scrollable bg-light-grey flex column center justify-center">
          <div class="flex column center justify-center">
            Loading styles
            <div class="flex center margin-top">
              <i class="fa-solid fa-circle-notch fa-2xl fa-spin"></i>
            </div>
          </div>
        </div>
      } @else if (!warehouse && !isCustom) {
        <div class="margin-top-small full-width scrollable bg-light-grey flex column center justify-center">
          <div class="flex center padding">Select warehouse</div>
        </div>
      } @else if (!availablestyles.items.length) {
        <div class="margin-top-small full-width scrollable bg-light-grey flex column center justify-center">
          <div class="flex center padding">No styles found for this warehouse</div>
        </div>
      } @else {
        <div class="flex center margin-top">
          <div class="flex center">
            <i
              class="primary-dark hover margin-right-small hover fa {{
                getSelectedStyles().length ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
              }}"
              (click)="toggleSelectAll()"
            ></i>
            <b class="margin-right-smallest">{{ getSelectedStyles().length }}</b>
            Selected
          </div>
          @if (getSelectedStyles().length) {
            <span class="hover flex center primary margin-left-small" (click)="addSelectedStyles()">
              Add selected
              <i class="fa fa-angle-right margin-left-small"></i>
            </span>
          }
        </div>
        <div
          class="margin-top-small full-width scrollable border flex column padding-small gap"
          (scroll)="onStylesScroll($event)"
        >
          @for (item of availablestyles.items; track item) {
            <div
              class="flex column {{ isAdded(item) ? 'disabled' : '' }} {{
                item.status?.id == styleStatus.Shooting ? 'disabled' : ''
              }}"
            >
              <div class="flex between">
                <div class="flex center">
                  <i
                    class="primary-dark hover margin-right-small hover fa {{
                      item.selected ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
                    }} "
                    (click)="selectStyle(item)"
                  ></i>
                  <span class="hover flex column" (click)="addStyle(item)">
                    <div class="flex center">
                      {{ item.brand?.name }} - {{ item.code }} - {{ item.name }} - {{ item.gender?.name }}
                    </div>

                    <span class="small grey">
                      {{ item.category?.name }} -
                      {{ item.styleGroup?.name != item.category?.name ? item.styleGroup?.name + ' - ' : '' }}
                      {{ item.collection?.id }} {{ item.collection?.name }}
                    </span>
                  </span>
                </div>
                <div class="flex center">
                  <div class="margin-right-smallest">
                    @if (item.status?.id == styleStatus.MissingImages) {
                      <span class="nowrap radius bg-orange padding-right-smallest padding-left-smallest">
                        Missing media
                      </span>
                    }
                    @if (item.status?.id == styleStatus.Shooting) {
                      <span class="nowrap radius bg-primary white padding-right-smallest padding-left-smallest">
                        Shooting in progress
                      </span>
                    }
                    @if (item.status?.id == styleStatus.Confirmed) {
                      <span class="nowrap radius bg-primary white padding-right-smallest padding-left-smallest">
                        Confirmed images
                      </span>
                    }
                  </div>
                  @if (!isAdded(item)) {
                    <span class="hover flex center primary margin-left-small" (click)="addStyle(item)">
                      Add
                      <i class="fa fa-angle-right margin-left-small"></i>
                    </span>
                  } @else {
                    <span class="grey margin-left-small">Added</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="flex center arrow flex-0 padding">
      <i class="fa fa-arrow-right primary fa-2xl"></i>
    </div>
    <div class="flex-1 flex column">
      <div class="flex center">
        <b>Selected styles</b>
      </div>

      @if (addedStyles.length) {
        <div class="flex center margin-top">
          <div class="flex center">
            <i
              class="primary-dark hover margin-right-small hover fa {{
                getSelectedAddedStyles().length ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
              }}"
              (click)="toggleSelectAllAdded()"
            ></i>
            <b class="margin-right-smallest">{{ getSelectedAddedStyles().length }}</b>
            Selected
          </div>
          @if (getSelectedAddedStyles().length) {
            <span class="hover flex center red margin-left-small" (click)="removeSelectedStyles()">
              <i class="fa fa-angle-left margin-right-small"></i>
              Remove selected
            </span>
          }
        </div>
      }
      <div class="full-width fix-height scrollable margin-top-small flex column border dashed">
        @for (item of addedStyles; track item) {
          <div class="flex column">
            <div class="flex between padding-smallest padding-left-small padding-right-small">
              <div class="flex flex-1">
                <i
                  class="primary-dark hover margin-right-small hover fa {{
                    item.selected ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
                  }}"
                  (click)="selectAddedStyle(item)"
                ></i>
                <div class="flex column flex-1">
                  <div class="flex center between">
                    <div class="flex column">
                      <div class="flex wrap">
                        {{ item.brand.name }} - {{ item.code }} - {{ item.name }} - {{ item.gender.name }}
                      </div>
                      <span class="small grey">
                        {{ item.category.name }} -
                        {{ item.styleGroup.name != item.category.name ? item.styleGroup.name + ' - ' : '' }}
                        {{ item.collection?.name }}
                      </span>
                    </div>

                    <span class="hover flex red center margin-left-small" (click)="removeStyle(item)">
                      <i class="fa-solid fa-angle-left margin-right-small"></i>
                      Remove
                    </span>
                  </div>

                  <div class=" ">
                    @for (color of item.colors; track color; let last = $last) {
                      <div class="flex center">
                        {{ color.name }}
                        <span
                          class="margin-left-smallest bg-light-grey padding-left-smallest padding-right-smallest radius"
                        >
                          Size {{ color.size?.name }}
                        </span>
                        @if (isColorAlreadyInOrder(item, color.id, color.size?.id)) {
                          <span
                            class="margin-left-smallest bg-orange red padding-left-smallest padding-right-smallest radius"
                          >
                            Already in order
                          </span>
                        }
                      </div>
                    } @empty {
                      <span class="bg-orange">No colors selected</span>
                    }

                    <span class="hover flex red center primary" (click)="openManageColorsSizesModal(item)">
                      Choose colors/sizes
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="flex column end margin-top">
    <div class="flex center">
      <button (click)="close()" class="stroked margin-right-small">
        <i class="fa-solid fa-undo"></i>
        Discard
      </button>

      <button (click)="apply()" [disabled]="!addedStyles.length">
        <i class="fa-solid fa-check"></i>
        @if (addedStyles.length) {
          Add {{ addedStyles.length }} {{ addedStyles.length == 1 ? 'product' : 'products' }}
        } @else {
          Add products
        }
      </button>
    </div>
  </div>
</div>
